export const APP_DIERENBOS = 'dierenbos';
export const APP_BEEKSEBERGEN = 'beeksebergen';
